let toastInstance = null;

export default {
  install(Vue) {
    Vue.prototype.$toast = {
      success(message, duration = 3000) {
        if (toastInstance) {
          toastInstance.show(message, 'success', duration)
        }
      },
      error(message, duration = 3000) {
        if (toastInstance) {
          toastInstance.show(message, 'error', duration)
        }
      },
      warning(message, duration = 3000) {
        if (toastInstance) {
          toastInstance.show(message, 'warning', duration)
        }
      },
      _setInstance(instance) {
        toastInstance = instance
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/plugins/toast.js